import type { Descriptor, Struct } from '@yp/common/schema/descriptor.ts';
import { DocumentReference, FieldValue, Timestamp } from 'firebase/firestore';
import { GeneralConverter } from './descriptor.ts';

export function converterOf<T extends Struct>(desc: Descriptor<T>) {
  return new GeneralConverter(desc, {
    docRef: DocumentReference,
    fieldVal: FieldValue,
    ts: Timestamp,
    tsFromMillis: (ms) => Timestamp.fromMillis(ms),
  });
}
